import { Card, Typography } from 'antd';
import { type ReactNode } from 'react';

export const EnvironmentIndicator = (): ReactNode => {
  return (
    <Card
      style={{
        position: 'absolute',
        bottom: 0,
        left: `50%`,
        transform: 'translateX(-50%)',
        zIndex: 1000,
        borderEndStartRadius: 0,
        borderEndEndRadius: 0,
      }}
      styles={{ body: { padding: 4 } }}
    >
      <Typography.Text style={{ paddingInline: 6 }} disabled>
        v{process.env.REACT_APP_VERSION}{' '}
        {process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : ''}
      </Typography.Text>
    </Card>
  );
};
